import { LinkPreview } from '@shared/scenes/chat/linkPreview';
import { API } from '@shared/types/api';

interface MBLinkPreviewFromTokensProps {
  message: API.ChatMessageFragment;
  align: 'left' | 'right';
  isGroupedWithBelow: boolean;
}

/*
    Render link preview based on a message's tokens. It shows the first link, if any.
*/
export function MBLinkPreviewFromTokens({
  message,
  align,
  isGroupedWithBelow,
}: MBLinkPreviewFromTokensProps) {
  const urlToken = message.meta.tokens.find(token => token?.type === 'url');
  if (!urlToken) {
    return null;
  }

  return <LinkPreview url={urlToken.value} align={align} isGroupedWithBelow={isGroupedWithBelow} />;
}
